import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalController } from '@ionic/angular';
import { QuickRegisterFormComponent } from '@libs/crud-profile-lib';
import { PlayerRegistrationService } from '@libs/util-ui';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';
import { take } from 'rxjs';

import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

/**
 * Cadastro rápido de cliente em MODAL — para fluxos que já estão dentro de
 * modal (event-creator → find-player → "+"). A rota /add-athlete renderizaria
 * por baixo do modal aberto; empilhar mantém o contexto da reserva vivo.
 *
 * Fecha sozinho no sucesso: o form (navigateOnSuccess=false) notifica o
 * e-mail via PlayerRegistrationService.onRegistered() e devolvemos ele no
 * dismiss — o chamador usa o e-mail para auto-selecionar o recém-criado.
 */
@Component({
  selector: 'lessor-quick-register-modal',
  template: `
    <!-- Mesmo header do client-update-modal: header-toolbar pinta com
         --ion-color-header e ESPERA .icon-style/.header-title p/ os brancos. -->
    <ion-header>
      <ion-toolbar class="header-toolbar">
        <ion-title class="header-title">Cadastrar novo cliente</ion-title>
        <ion-buttons slot="end">
          <ion-button aria-label="Fechar" (click)="dismiss()">
            <ion-icon class="icon-style" slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <crud-quick-register-form
        [isAthlete]="false"
        [navigateOnSuccess]="false"
      ></crud-quick-register-form>
    </ion-content>
  `,
  imports: [
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonTitle,
    IonToolbar,
    QuickRegisterFormComponent,
  ],
})
export class QuickRegisterModalComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly playerRegistration = inject(PlayerRegistrationService);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    addIcons({ close });
    this.playerRegistration
      .onRegistered()
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe((email) => this.modalCtrl.dismiss(email));
  }

  dismiss() {
    this.modalCtrl.dismiss(null);
  }
}
